// extracted by mini-css-extract-plugin
export default {"pageContainer":"AppLayout_pageContainer__eeC2b","childrenContainer":"AppLayout_childrenContainer__LXQTn","child":"AppLayout_child__SxIOS"};